__turbopack_context__.v({
  "closeButton": "OverlayDrawer-module__sSpSza__closeButton",
  "content": "OverlayDrawer-module__sSpSza__content",
  "dialog": "OverlayDrawer-module__sSpSza__dialog",
  "header": "OverlayDrawer-module__sSpSza__header",
  "headerContent": "OverlayDrawer-module__sSpSza__headerContent",
  "modal": "OverlayDrawer-module__sSpSza__modal",
  "modal-fade": "OverlayDrawer-module__sSpSza__modal-fade",
  "modal-slideacross": "OverlayDrawer-module__sSpSza__modal-slideacross",
  "modal-slideup": "OverlayDrawer-module__sSpSza__modal-slideup",
  "modalOverlay": "OverlayDrawer-module__sSpSza__modalOverlay",
});
